/*
    Selectパーツを生成するコンポーネント
    props
        values:{
            label:オプションで表示させたい文言
            value:データ送信の際の値
        }の配列
        selected:選択しているvalueの指定
 */

import React from "react"

interface Value {
  label: string
  value: string | number,
}

interface Props {
  dataSource: Value[],
  selected: string | number,
  className?: string,
  onChange?: (data: string | number) => void,
  action?: (params: {}) => any | null,
}

export function Select(props: Props) {
  const { dataSource, className, selected, onChange, action = null } = props
  return (
    <>
      <select className={`${className}`} value={selected} onChange={(e) => {
        onChange?.apply(this, [dataSource[e.target.selectedIndex].value])
        if (action !== null) {
          if (action({}) === false) {
            return
          }
        }
      }}>
        {dataSource.map((item, index) => {
          return (
            <option key={index} value={item.value}>{item.label}</option>
          )
        })}
      </select>
    </>
  )
}
